/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Mission Impact API
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AddSourceRequest,
  AddSourceResponse,
  AddSourceTableRequest,
  AddSourceTableResponse,
  AddTargetRequest,
  AddTargetResponse,
  AgentDto,
  AgentLogsPaginatedResult,
  AgentTaskDto,
  AllRunsPaginatedResult,
  AllSourceTablesResult,
  AvailableSourceTableDto,
  CompleteTaskRequest,
  ConnectionTestResponse,
  CreateAgentRequest,
  CreateAgentResponse,
  CreateProfileRequest,
  CreateProfileResponse,
  CreateScheduleRequest,
  CreateScheduleResponse,
  CreateSupportCommentRequest,
  CreateSupportTicketRequest,
  DeleteSourceTablesById200,
  ErrorProblemDetails,
  FailTaskRequest,
  GetAgentLogsParams,
  GetAgentTasksParams,
  GetAllRunsRequest,
  GetAllSourceTablesRequest,
  GetRunMetadataRequest,
  GetSupportPartnerDarkLogoParams,
  GetSupportPartnerLogoParams,
  GetSupportTicketsParams,
  HeartbeatRequest,
  HeartbeatResponse,
  ListProfilesRequest,
  ListSourceTablesRequest,
  OrgSettingsDto,
  PagedResultSupportTicketSummaryDto,
  PaginatedResultProfileDto,
  PaginatedResultSourceTableDto,
  PatchTargetsById200,
  PostProfileSync200,
  PostSourceTableSync200,
  ProfileWithSourceAndTargetDto,
  PutSourceTableState200,
  PutSources200,
  RegenerateTokenResponse,
  RegisterAgentRequest,
  RegisterAgentResponse,
  RunMetadataPaginatedResult,
  ScheduleDto,
  SourceDto,
  SourceTableDto,
  StartTaskResponse,
  SuccessResponse,
  SupportAttachmentDto,
  SupportAttachmentPolicyDto,
  SupportAttachmentUnavailableProblemDetails,
  SupportAttachmentUploadForm,
  SupportCommentDto,
  SupportPartnerDto,
  SupportTicketCountsDto,
  SupportTicketDetailDto,
  SyncRequest,
  TargetDto,
  TargetSchemaResponse,
  TestAzureSqlConnectionRequest,
  TestBcConnectionRequest,
  TestBcConnectionResponse,
  TestDataverseConnectionRequest,
  TestSalesforceConnectionRequest,
  UpdateAgentRequest,
  UpdateOrgSettingsRequest,
  UpdateProfileRequest,
  UpdateSourceRequest,
  UpdateSourceTableStateRequest,
  UpdateTargetRequest,
  Void,
} from '../missionImpactAPI.schemas';

import { instance } from '../../mutator-control-plane';
import type { ErrorType } from '../../mutator-control-plane';

/**
 * Returns paginated log entries for an agent, sorted newest-first.
 * @summary List agent logs
 */
export const getAgentLogs = (
  orgId: string,
  agentId: string,
  params?: GetAgentLogsParams,
  signal?: AbortSignal
) => {
  return instance<AgentLogsPaginatedResult>({
    url: `/orgs/${orgId}/agents/${agentId}/logs`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetAgentLogsQueryKey = (
  orgId?: string,
  agentId?: string,
  params?: GetAgentLogsParams
) => {
  return [`/orgs/${orgId}/agents/${agentId}/logs`, ...(params ? [params] : [])] as const;
};

export const getGetAgentLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgentLogs>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  agentId: string,
  params?: GetAgentLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentLogs>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgentLogsQueryKey(orgId, agentId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentLogs>>> = ({ signal }) =>
    getAgentLogs(orgId, agentId, params, signal);

  return { queryKey, queryFn, enabled: !!(orgId && agentId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgentLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAgentLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentLogs>>>;
export type GetAgentLogsQueryError = ErrorType<ErrorProblemDetails>;

export function useGetAgentLogs<
  TData = Awaited<ReturnType<typeof getAgentLogs>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  agentId: string,
  params: undefined | GetAgentLogsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentLogs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentLogs>>,
          TError,
          Awaited<ReturnType<typeof getAgentLogs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAgentLogs<
  TData = Awaited<ReturnType<typeof getAgentLogs>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  agentId: string,
  params?: GetAgentLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentLogs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentLogs>>,
          TError,
          Awaited<ReturnType<typeof getAgentLogs>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAgentLogs<
  TData = Awaited<ReturnType<typeof getAgentLogs>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  agentId: string,
  params?: GetAgentLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentLogs>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List agent logs
 */

export function useGetAgentLogs<
  TData = Awaited<ReturnType<typeof getAgentLogs>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  agentId: string,
  params?: GetAgentLogsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentLogs>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAgentLogsQueryOptions(orgId, agentId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new self-hosted agent and generates a one-time registration token. Requires Admin or Operator role.
 * @summary Create agent
 */
export const postAgents = (
  orgId: string,
  createAgentRequest: CreateAgentRequest,
  signal?: AbortSignal
) => {
  return instance<CreateAgentResponse>({
    url: `/orgs/${orgId}/agents`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createAgentRequest,
    signal,
  });
};

export const getPostAgentsMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgents>>,
    TError,
    { orgId: string; data: CreateAgentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAgents>>,
  TError,
  { orgId: string; data: CreateAgentRequest },
  TContext
> => {
  const mutationKey = ['postAgents'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAgents>>,
    { orgId: string; data: CreateAgentRequest }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return postAgents(orgId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentsMutationResult = NonNullable<Awaited<ReturnType<typeof postAgents>>>;
export type PostAgentsMutationBody = CreateAgentRequest;
export type PostAgentsMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Create agent
 */
export const usePostAgents = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAgents>>,
      TError,
      { orgId: string; data: CreateAgentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAgents>>,
  TError,
  { orgId: string; data: CreateAgentRequest },
  TContext
> => {
  const mutationOptions = getPostAgentsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves all self-hosted agents for an organization.
 * @summary List agents
 */
export const getAgents = (orgId: string, signal?: AbortSignal) => {
  return instance<AgentDto[]>({ url: `/orgs/${orgId}/agents`, method: 'GET', signal });
};

export const getGetAgentsQueryKey = (orgId?: string) => {
  return [`/orgs/${orgId}/agents`] as const;
};

export const getGetAgentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgents>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgents>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgentsQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgents>>> = ({ signal }) =>
    getAgents(orgId, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAgentsQueryResult = NonNullable<Awaited<ReturnType<typeof getAgents>>>;
export type GetAgentsQueryError = ErrorType<ErrorProblemDetails>;

export function useGetAgents<
  TData = Awaited<ReturnType<typeof getAgents>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgents>>,
          TError,
          Awaited<ReturnType<typeof getAgents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAgents<
  TData = Awaited<ReturnType<typeof getAgents>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgents>>,
          TError,
          Awaited<ReturnType<typeof getAgents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAgents<
  TData = Awaited<ReturnType<typeof getAgents>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgents>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List agents
 */

export function useGetAgents<
  TData = Awaited<ReturnType<typeof getAgents>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgents>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAgentsQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves detailed information about a specific self-hosted agent.
 * @summary Get agent by ID
 */
export const getAgentsById = (orgId: string, agentId: string, signal?: AbortSignal) => {
  return instance<AgentDto>({ url: `/orgs/${orgId}/agents/${agentId}`, method: 'GET', signal });
};

export const getGetAgentsByIdQueryKey = (orgId?: string, agentId?: string) => {
  return [`/orgs/${orgId}/agents/${agentId}`] as const;
};

export const getGetAgentsByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgentsById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  agentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentsById>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgentsByIdQueryKey(orgId, agentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentsById>>> = ({ signal }) =>
    getAgentsById(orgId, agentId, signal);

  return { queryKey, queryFn, enabled: !!(orgId && agentId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgentsById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAgentsByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentsById>>>;
export type GetAgentsByIdQueryError = ErrorType<ErrorProblemDetails>;

export function useGetAgentsById<
  TData = Awaited<ReturnType<typeof getAgentsById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  agentId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentsById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentsById>>,
          TError,
          Awaited<ReturnType<typeof getAgentsById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAgentsById<
  TData = Awaited<ReturnType<typeof getAgentsById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  agentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentsById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentsById>>,
          TError,
          Awaited<ReturnType<typeof getAgentsById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAgentsById<
  TData = Awaited<ReturnType<typeof getAgentsById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  agentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentsById>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get agent by ID
 */

export function useGetAgentsById<
  TData = Awaited<ReturnType<typeof getAgentsById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  agentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentsById>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAgentsByIdQueryOptions(orgId, agentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates a self-hosted agent's name or status. Requires Admin or Operator role.
 * @summary Update agent
 */
export const patchAgentsById = (
  orgId: string,
  agentId: string,
  updateAgentRequest: UpdateAgentRequest
) => {
  return instance<SuccessResponse>({
    url: `/orgs/${orgId}/agents/${agentId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateAgentRequest,
  });
};

export const getPatchAgentsByIdMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchAgentsById>>,
    TError,
    { orgId: string; agentId: string; data: UpdateAgentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchAgentsById>>,
  TError,
  { orgId: string; agentId: string; data: UpdateAgentRequest },
  TContext
> => {
  const mutationKey = ['patchAgentsById'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchAgentsById>>,
    { orgId: string; agentId: string; data: UpdateAgentRequest }
  > = (props) => {
    const { orgId, agentId, data } = props ?? {};

    return patchAgentsById(orgId, agentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchAgentsByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchAgentsById>>
>;
export type PatchAgentsByIdMutationBody = UpdateAgentRequest;
export type PatchAgentsByIdMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Update agent
 */
export const usePatchAgentsById = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchAgentsById>>,
      TError,
      { orgId: string; agentId: string; data: UpdateAgentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchAgentsById>>,
  TError,
  { orgId: string; agentId: string; data: UpdateAgentRequest },
  TContext
> => {
  const mutationOptions = getPatchAgentsByIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a self-hosted agent and all associated data. Requires Admin or Operator role.
 * @summary Delete agent
 */
export const deleteAgentsById = (orgId: string, agentId: string) => {
  return instance<SuccessResponse>({ url: `/orgs/${orgId}/agents/${agentId}`, method: 'DELETE' });
};

export const getDeleteAgentsByIdMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAgentsById>>,
    TError,
    { orgId: string; agentId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAgentsById>>,
  TError,
  { orgId: string; agentId: string },
  TContext
> => {
  const mutationKey = ['deleteAgentsById'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAgentsById>>,
    { orgId: string; agentId: string }
  > = (props) => {
    const { orgId, agentId } = props ?? {};

    return deleteAgentsById(orgId, agentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAgentsByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAgentsById>>
>;

export type DeleteAgentsByIdMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Delete agent
 */
export const useDeleteAgentsById = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAgentsById>>,
      TError,
      { orgId: string; agentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAgentsById>>,
  TError,
  { orgId: string; agentId: string },
  TContext
> => {
  const mutationOptions = getDeleteAgentsByIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Generates a new one-time registration token for an agent. Requires Admin or Operator role.
 * @summary Regenerate registration token
 */
export const postAgentsRegenerateToken = (orgId: string, agentId: string, signal?: AbortSignal) => {
  return instance<RegenerateTokenResponse>({
    url: `/orgs/${orgId}/agents/${agentId}/regenerate-token`,
    method: 'POST',
    signal,
  });
};

export const getPostAgentsRegenerateTokenMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsRegenerateToken>>,
    TError,
    { orgId: string; agentId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAgentsRegenerateToken>>,
  TError,
  { orgId: string; agentId: string },
  TContext
> => {
  const mutationKey = ['postAgentsRegenerateToken'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAgentsRegenerateToken>>,
    { orgId: string; agentId: string }
  > = (props) => {
    const { orgId, agentId } = props ?? {};

    return postAgentsRegenerateToken(orgId, agentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentsRegenerateTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAgentsRegenerateToken>>
>;

export type PostAgentsRegenerateTokenMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Regenerate registration token
 */
export const usePostAgentsRegenerateToken = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAgentsRegenerateToken>>,
      TError,
      { orgId: string; agentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAgentsRegenerateToken>>,
  TError,
  { orgId: string; agentId: string },
  TContext
> => {
  const mutationOptions = getPostAgentsRegenerateTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Starts a health check of the agent. Poll the agent for the result. Requires Admin or Operator role.
 * @summary Confirm agent health
 */
export const postAgentsHealthCheck = (orgId: string, agentId: string, signal?: AbortSignal) => {
  return instance<void>({
    url: `/orgs/${orgId}/agents/${agentId}/health-check`,
    method: 'POST',
    signal,
  });
};

export const getPostAgentsHealthCheckMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentsHealthCheck>>,
    TError,
    { orgId: string; agentId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAgentsHealthCheck>>,
  TError,
  { orgId: string; agentId: string },
  TContext
> => {
  const mutationKey = ['postAgentsHealthCheck'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAgentsHealthCheck>>,
    { orgId: string; agentId: string }
  > = (props) => {
    const { orgId, agentId } = props ?? {};

    return postAgentsHealthCheck(orgId, agentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentsHealthCheckMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAgentsHealthCheck>>
>;

export type PostAgentsHealthCheckMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Confirm agent health
 */
export const usePostAgentsHealthCheck = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAgentsHealthCheck>>,
      TError,
      { orgId: string; agentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAgentsHealthCheck>>,
  TError,
  { orgId: string; agentId: string },
  TContext
> => {
  const mutationOptions = getPostAgentsHealthCheckMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Exchanges a one-time registration token for agent credentials. Called by the agent during first-time setup.
 * @summary Register agent
 */
export const postAgentRegister = (
  registerAgentRequest: RegisterAgentRequest,
  signal?: AbortSignal
) => {
  return instance<RegisterAgentResponse>({
    url: `/v1/agent/register`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: registerAgentRequest,
    signal,
  });
};

export const getPostAgentRegisterMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentRegister>>,
    TError,
    { data: RegisterAgentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAgentRegister>>,
  TError,
  { data: RegisterAgentRequest },
  TContext
> => {
  const mutationKey = ['postAgentRegister'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAgentRegister>>,
    { data: RegisterAgentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postAgentRegister(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentRegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAgentRegister>>
>;
export type PostAgentRegisterMutationBody = RegisterAgentRequest;
export type PostAgentRegisterMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Register agent
 */
export const usePostAgentRegister = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAgentRegister>>,
      TError,
      { data: RegisterAgentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAgentRegister>>,
  TError,
  { data: RegisterAgentRequest },
  TContext
> => {
  const mutationOptions = getPostAgentRegisterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Reports agent status and version. Called periodically by the agent.
 * @summary Agent heartbeat
 */
export const postAgentHeartbeat = (heartbeatRequest: HeartbeatRequest, signal?: AbortSignal) => {
  return instance<HeartbeatResponse>({
    url: `/v1/agent/heartbeat`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: heartbeatRequest,
    signal,
  });
};

export const getPostAgentHeartbeatMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentHeartbeat>>,
    TError,
    { data: HeartbeatRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAgentHeartbeat>>,
  TError,
  { data: HeartbeatRequest },
  TContext
> => {
  const mutationKey = ['postAgentHeartbeat'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAgentHeartbeat>>,
    { data: HeartbeatRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postAgentHeartbeat(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentHeartbeatMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAgentHeartbeat>>
>;
export type PostAgentHeartbeatMutationBody = HeartbeatRequest;
export type PostAgentHeartbeatMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Agent heartbeat
 */
export const usePostAgentHeartbeat = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAgentHeartbeat>>,
      TError,
      { data: HeartbeatRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAgentHeartbeat>>,
  TError,
  { data: HeartbeatRequest },
  TContext
> => {
  const mutationOptions = getPostAgentHeartbeatMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Marks a task as Running and returns target connection details. Called by the agent when picking up a task.
 * @summary Start task
 */
export const postAgentTasksStart = (taskId: string, signal?: AbortSignal) => {
  return instance<StartTaskResponse>({
    url: `/v1/agent/tasks/${taskId}/start`,
    method: 'POST',
    signal,
  });
};

export const getPostAgentTasksStartMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentTasksStart>>,
    TError,
    { taskId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAgentTasksStart>>,
  TError,
  { taskId: string },
  TContext
> => {
  const mutationKey = ['postAgentTasksStart'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAgentTasksStart>>,
    { taskId: string }
  > = (props) => {
    const { taskId } = props ?? {};

    return postAgentTasksStart(taskId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentTasksStartMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAgentTasksStart>>
>;

export type PostAgentTasksStartMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Start task
 */
export const usePostAgentTasksStart = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAgentTasksStart>>,
      TError,
      { taskId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAgentTasksStart>>,
  TError,
  { taskId: string },
  TContext
> => {
  const mutationOptions = getPostAgentTasksStartMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Reports task completion. Idempotent: duplicate calls for a completed task are no-ops.
 * @summary Complete task
 */
export const postAgentTasksComplete = (
  taskId: string,
  completeTaskRequest: CompleteTaskRequest,
  signal?: AbortSignal
) => {
  return instance<SuccessResponse>({
    url: `/v1/agent/tasks/${taskId}/complete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: completeTaskRequest,
    signal,
  });
};

export const getPostAgentTasksCompleteMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentTasksComplete>>,
    TError,
    { taskId: string; data: CompleteTaskRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAgentTasksComplete>>,
  TError,
  { taskId: string; data: CompleteTaskRequest },
  TContext
> => {
  const mutationKey = ['postAgentTasksComplete'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAgentTasksComplete>>,
    { taskId: string; data: CompleteTaskRequest }
  > = (props) => {
    const { taskId, data } = props ?? {};

    return postAgentTasksComplete(taskId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentTasksCompleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAgentTasksComplete>>
>;
export type PostAgentTasksCompleteMutationBody = CompleteTaskRequest;
export type PostAgentTasksCompleteMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Complete task
 */
export const usePostAgentTasksComplete = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAgentTasksComplete>>,
      TError,
      { taskId: string; data: CompleteTaskRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAgentTasksComplete>>,
  TError,
  { taskId: string; data: CompleteTaskRequest },
  TContext
> => {
  const mutationOptions = getPostAgentTasksCompleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Reports task failure. Idempotent: duplicate calls for a failed task are no-ops.
 * @summary Fail task
 */
export const postAgentTasksFail = (
  taskId: string,
  failTaskRequest: FailTaskRequest,
  signal?: AbortSignal
) => {
  return instance<SuccessResponse>({
    url: `/v1/agent/tasks/${taskId}/fail`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: failTaskRequest,
    signal,
  });
};

export const getPostAgentTasksFailMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgentTasksFail>>,
    TError,
    { taskId: string; data: FailTaskRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAgentTasksFail>>,
  TError,
  { taskId: string; data: FailTaskRequest },
  TContext
> => {
  const mutationKey = ['postAgentTasksFail'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAgentTasksFail>>,
    { taskId: string; data: FailTaskRequest }
  > = (props) => {
    const { taskId, data } = props ?? {};

    return postAgentTasksFail(taskId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAgentTasksFailMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAgentTasksFail>>
>;
export type PostAgentTasksFailMutationBody = FailTaskRequest;
export type PostAgentTasksFailMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Fail task
 */
export const usePostAgentTasksFail = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAgentTasksFail>>,
      TError,
      { taskId: string; data: FailTaskRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAgentTasksFail>>,
  TError,
  { taskId: string; data: FailTaskRequest },
  TContext
> => {
  const mutationOptions = getPostAgentTasksFailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns tasks for the authenticated agent filtered by status. Used for orphan recovery.
 * @summary List agent tasks by status
 */
export const getAgentTasks = (params: GetAgentTasksParams, signal?: AbortSignal) => {
  return instance<AgentTaskDto[]>({ url: `/v1/agent/tasks`, method: 'GET', params, signal });
};

export const getGetAgentTasksQueryKey = (params?: GetAgentTasksParams) => {
  return [`/v1/agent/tasks`, ...(params ? [params] : [])] as const;
};

export const getGetAgentTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgentTasks>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  params: GetAgentTasksParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentTasks>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgentTasksQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentTasks>>> = ({ signal }) =>
    getAgentTasks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgentTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAgentTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentTasks>>>;
export type GetAgentTasksQueryError = ErrorType<ErrorProblemDetails>;

export function useGetAgentTasks<
  TData = Awaited<ReturnType<typeof getAgentTasks>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  params: GetAgentTasksParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentTasks>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentTasks>>,
          TError,
          Awaited<ReturnType<typeof getAgentTasks>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAgentTasks<
  TData = Awaited<ReturnType<typeof getAgentTasks>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  params: GetAgentTasksParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentTasks>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentTasks>>,
          TError,
          Awaited<ReturnType<typeof getAgentTasks>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAgentTasks<
  TData = Awaited<ReturnType<typeof getAgentTasks>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  params: GetAgentTasksParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentTasks>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List agent tasks by status
 */

export function useGetAgentTasks<
  TData = Awaited<ReturnType<typeof getAgentTasks>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  params: GetAgentTasksParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentTasks>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAgentTasksQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves paginated run metadata across all profiles in an organization.
 * @summary Get all runs
 */
export const getAllRuns = (
  orgId: string,
  getAllRunsRequest: GetAllRunsRequest,
  signal?: AbortSignal
) => {
  return instance<AllRunsPaginatedResult>({
    url: `/orgs/${orgId}/runs/list`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: getAllRunsRequest,
    signal,
  });
};

export const getGetAllRunsQueryKey = (orgId?: string, getAllRunsRequest?: GetAllRunsRequest) => {
  return [`/orgs/${orgId}/runs/list`, getAllRunsRequest] as const;
};

export const getGetAllRunsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllRuns>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  getAllRunsRequest: GetAllRunsRequest,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRuns>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllRunsQueryKey(orgId, getAllRunsRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllRuns>>> = ({ signal }) =>
    getAllRuns(orgId, getAllRunsRequest, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllRuns>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllRunsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllRuns>>>;
export type GetAllRunsQueryError = ErrorType<ErrorProblemDetails>;

export function useGetAllRuns<
  TData = Awaited<ReturnType<typeof getAllRuns>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  getAllRunsRequest: GetAllRunsRequest,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRuns>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllRuns>>,
          TError,
          Awaited<ReturnType<typeof getAllRuns>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllRuns<
  TData = Awaited<ReturnType<typeof getAllRuns>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  getAllRunsRequest: GetAllRunsRequest,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRuns>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllRuns>>,
          TError,
          Awaited<ReturnType<typeof getAllRuns>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllRuns<
  TData = Awaited<ReturnType<typeof getAllRuns>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  getAllRunsRequest: GetAllRunsRequest,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRuns>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all runs
 */

export function useGetAllRuns<
  TData = Awaited<ReturnType<typeof getAllRuns>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  getAllRunsRequest: GetAllRunsRequest,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRuns>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAllRunsQueryOptions(orgId, getAllRunsRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves all source tables across all profiles in an organization.
 * @summary Get all source tables
 */
export const getAllSourceTables = (
  orgId: string,
  getAllSourceTablesRequest: GetAllSourceTablesRequest,
  signal?: AbortSignal
) => {
  return instance<AllSourceTablesResult>({
    url: `/orgs/${orgId}/sourcetables/list`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: getAllSourceTablesRequest,
    signal,
  });
};

export const getGetAllSourceTablesMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAllSourceTables>>,
    TError,
    { orgId: string; data: GetAllSourceTablesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAllSourceTables>>,
  TError,
  { orgId: string; data: GetAllSourceTablesRequest },
  TContext
> => {
  const mutationKey = ['getAllSourceTables'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAllSourceTables>>,
    { orgId: string; data: GetAllSourceTablesRequest }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return getAllSourceTables(orgId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAllSourceTablesMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAllSourceTables>>
>;
export type GetAllSourceTablesMutationBody = GetAllSourceTablesRequest;
export type GetAllSourceTablesMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Get all source tables
 */
export const useGetAllSourceTables = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAllSourceTables>>,
      TError,
      { orgId: string; data: GetAllSourceTablesRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getAllSourceTables>>,
  TError,
  { orgId: string; data: GetAllSourceTablesRequest },
  TContext
> => {
  const mutationOptions = getGetAllSourceTablesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves organization settings. Creates default settings if they don't exist.
 * @summary Get organization settings
 */
export const getOrgSettings = (orgId: string, signal?: AbortSignal) => {
  return instance<OrgSettingsDto>({ url: `/orgs/${orgId}/settings`, method: 'GET', signal });
};

export const getGetOrgSettingsQueryKey = (orgId?: string) => {
  return [`/orgs/${orgId}/settings`] as const;
};

export const getGetOrgSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrgSettings>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrgSettingsQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgSettings>>> = ({ signal }) =>
    getOrgSettings(orgId, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrgSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetOrgSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgSettings>>>;
export type GetOrgSettingsQueryError = ErrorType<ErrorProblemDetails>;

export function useGetOrgSettings<
  TData = Awaited<ReturnType<typeof getOrgSettings>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrgSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOrgSettings<
  TData = Awaited<ReturnType<typeof getOrgSettings>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrgSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOrgSettings<
  TData = Awaited<ReturnType<typeof getOrgSettings>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get organization settings
 */

export function useGetOrgSettings<
  TData = Awaited<ReturnType<typeof getOrgSettings>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgSettings>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetOrgSettingsQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates organization settings.
 * @summary Update organization settings
 */
export const updateOrgSettings = (
  orgId: string,
  updateOrgSettingsRequest: UpdateOrgSettingsRequest
) => {
  return instance<void>({
    url: `/orgs/${orgId}/settings`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateOrgSettingsRequest,
  });
};

export const getUpdateOrgSettingsMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrgSettings>>,
    TError,
    { orgId: string; data: UpdateOrgSettingsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrgSettings>>,
  TError,
  { orgId: string; data: UpdateOrgSettingsRequest },
  TContext
> => {
  const mutationKey = ['updateOrgSettings'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrgSettings>>,
    { orgId: string; data: UpdateOrgSettingsRequest }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return updateOrgSettings(orgId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrgSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrgSettings>>
>;
export type UpdateOrgSettingsMutationBody = UpdateOrgSettingsRequest;
export type UpdateOrgSettingsMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Update organization settings
 */
export const useUpdateOrgSettings = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOrgSettings>>,
      TError,
      { orgId: string; data: UpdateOrgSettingsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateOrgSettings>>,
  TError,
  { orgId: string; data: UpdateOrgSettingsRequest },
  TContext
> => {
  const mutationOptions = getUpdateOrgSettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a new data processing profile for an organization. Requires Admin or Operator role.
 * @summary Create profile
 */
export const postProfiles = (
  orgId: string,
  createProfileRequest: CreateProfileRequest,
  signal?: AbortSignal
) => {
  return instance<CreateProfileResponse>({
    url: `/orgs/${orgId}/profiles`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createProfileRequest,
    signal,
  });
};

export const getPostProfilesMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postProfiles>>,
    TError,
    { orgId: string; data: CreateProfileRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postProfiles>>,
  TError,
  { orgId: string; data: CreateProfileRequest },
  TContext
> => {
  const mutationKey = ['postProfiles'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postProfiles>>,
    { orgId: string; data: CreateProfileRequest }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return postProfiles(orgId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostProfilesMutationResult = NonNullable<Awaited<ReturnType<typeof postProfiles>>>;
export type PostProfilesMutationBody = CreateProfileRequest;
export type PostProfilesMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Create profile
 */
export const usePostProfiles = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postProfiles>>,
      TError,
      { orgId: string; data: CreateProfileRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postProfiles>>,
  TError,
  { orgId: string; data: CreateProfileRequest },
  TContext
> => {
  const mutationOptions = getPostProfilesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves detailed information about a specific profile by its ID, including linked source and target if available.
 * @summary Get profile by ID
 */
export const getProfilesById = (orgId: string, profileId: string, signal?: AbortSignal) => {
  return instance<ProfileWithSourceAndTargetDto>({
    url: `/orgs/${orgId}/profiles/${profileId}`,
    method: 'GET',
    signal,
  });
};

export const getGetProfilesByIdQueryKey = (orgId?: string, profileId?: string) => {
  return [`/orgs/${orgId}/profiles/${profileId}`] as const;
};

export const getGetProfilesByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfilesById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfilesById>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfilesByIdQueryKey(orgId, profileId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfilesById>>> = ({ signal }) =>
    getProfilesById(orgId, profileId, signal);

  return { queryKey, queryFn, enabled: !!(orgId && profileId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfilesById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetProfilesByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProfilesById>>>;
export type GetProfilesByIdQueryError = ErrorType<ErrorProblemDetails>;

export function useGetProfilesById<
  TData = Awaited<ReturnType<typeof getProfilesById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfilesById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfilesById>>,
          TError,
          Awaited<ReturnType<typeof getProfilesById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProfilesById<
  TData = Awaited<ReturnType<typeof getProfilesById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfilesById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfilesById>>,
          TError,
          Awaited<ReturnType<typeof getProfilesById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProfilesById<
  TData = Awaited<ReturnType<typeof getProfilesById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfilesById>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get profile by ID
 */

export function useGetProfilesById<
  TData = Awaited<ReturnType<typeof getProfilesById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfilesById>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetProfilesByIdQueryOptions(orgId, profileId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates a profile's properties. Requires Admin or Operator role.
 * @summary Update profile
 */
export const putProfiles = (
  orgId: string,
  profileId: string,
  updateProfileRequest: UpdateProfileRequest
) => {
  return instance<SuccessResponse>({
    url: `/orgs/${orgId}/profiles/${profileId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateProfileRequest,
  });
};

export const getPutProfilesMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putProfiles>>,
    TError,
    { orgId: string; profileId: string; data: UpdateProfileRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putProfiles>>,
  TError,
  { orgId: string; profileId: string; data: UpdateProfileRequest },
  TContext
> => {
  const mutationKey = ['putProfiles'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putProfiles>>,
    { orgId: string; profileId: string; data: UpdateProfileRequest }
  > = (props) => {
    const { orgId, profileId, data } = props ?? {};

    return putProfiles(orgId, profileId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutProfilesMutationResult = NonNullable<Awaited<ReturnType<typeof putProfiles>>>;
export type PutProfilesMutationBody = UpdateProfileRequest;
export type PutProfilesMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Update profile
 */
export const usePutProfiles = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putProfiles>>,
      TError,
      { orgId: string; profileId: string; data: UpdateProfileRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putProfiles>>,
  TError,
  { orgId: string; profileId: string; data: UpdateProfileRequest },
  TContext
> => {
  const mutationOptions = getPutProfilesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a profile. Requires Admin or Operator role.
 * @summary Delete profile
 */
export const deleteProfilesById = (orgId: string, profileId: string) => {
  return instance<SuccessResponse>({
    url: `/orgs/${orgId}/profiles/${profileId}`,
    method: 'DELETE',
  });
};

export const getDeleteProfilesByIdMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProfilesById>>,
    TError,
    { orgId: string; profileId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProfilesById>>,
  TError,
  { orgId: string; profileId: string },
  TContext
> => {
  const mutationKey = ['deleteProfilesById'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProfilesById>>,
    { orgId: string; profileId: string }
  > = (props) => {
    const { orgId, profileId } = props ?? {};

    return deleteProfilesById(orgId, profileId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProfilesByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProfilesById>>
>;

export type DeleteProfilesByIdMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Delete profile
 */
export const useDeleteProfilesById = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteProfilesById>>,
      TError,
      { orgId: string; profileId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteProfilesById>>,
  TError,
  { orgId: string; profileId: string },
  TContext
> => {
  const mutationOptions = getDeleteProfilesByIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves a paginated list of profiles for a tenant. Tenant is determined from X-Tenant-Id header or JWT claims.
 * @summary List profiles
 */
export const postListProfiles = (
  orgId: string,
  listProfilesRequest: ListProfilesRequest,
  signal?: AbortSignal
) => {
  return instance<PaginatedResultProfileDto>({
    url: `/orgs/${orgId}/profiles/list`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: listProfilesRequest,
    signal,
  });
};

export const getPostListProfilesMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postListProfiles>>,
    TError,
    { orgId: string; data: ListProfilesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postListProfiles>>,
  TError,
  { orgId: string; data: ListProfilesRequest },
  TContext
> => {
  const mutationKey = ['postListProfiles'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postListProfiles>>,
    { orgId: string; data: ListProfilesRequest }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return postListProfiles(orgId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostListProfilesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postListProfiles>>
>;
export type PostListProfilesMutationBody = ListProfilesRequest;
export type PostListProfilesMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary List profiles
 */
export const usePostListProfiles = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postListProfiles>>,
      TError,
      { orgId: string; data: ListProfilesRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postListProfiles>>,
  TError,
  { orgId: string; data: ListProfilesRequest },
  TContext
> => {
  const mutationOptions = getPostListProfilesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a new quiet time schedule for a profile. Requires Admin or Operator role.
 * @summary Create schedule
 */
export const postSchedules = (
  orgId: string,
  profileId: string,
  createScheduleRequest: CreateScheduleRequest,
  signal?: AbortSignal
) => {
  return instance<CreateScheduleResponse>({
    url: `/orgs/${orgId}/profiles/${profileId}/schedules`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createScheduleRequest,
    signal,
  });
};

export const getPostSchedulesMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSchedules>>,
    TError,
    { orgId: string; profileId: string; data: CreateScheduleRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSchedules>>,
  TError,
  { orgId: string; profileId: string; data: CreateScheduleRequest },
  TContext
> => {
  const mutationKey = ['postSchedules'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSchedules>>,
    { orgId: string; profileId: string; data: CreateScheduleRequest }
  > = (props) => {
    const { orgId, profileId, data } = props ?? {};

    return postSchedules(orgId, profileId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSchedulesMutationResult = NonNullable<Awaited<ReturnType<typeof postSchedules>>>;
export type PostSchedulesMutationBody = CreateScheduleRequest;
export type PostSchedulesMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Create schedule
 */
export const usePostSchedules = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSchedules>>,
      TError,
      { orgId: string; profileId: string; data: CreateScheduleRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postSchedules>>,
  TError,
  { orgId: string; profileId: string; data: CreateScheduleRequest },
  TContext
> => {
  const mutationOptions = getPostSchedulesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves all quiet time schedules for a profile.
 * @summary List schedules
 */
export const getSchedules = (orgId: string, profileId: string, signal?: AbortSignal) => {
  return instance<ScheduleDto[]>({
    url: `/orgs/${orgId}/profiles/${profileId}/schedules`,
    method: 'GET',
    signal,
  });
};

export const getGetSchedulesQueryKey = (orgId?: string, profileId?: string) => {
  return [`/orgs/${orgId}/profiles/${profileId}/schedules`] as const;
};

export const getGetSchedulesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSchedules>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedules>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSchedulesQueryKey(orgId, profileId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchedules>>> = ({ signal }) =>
    getSchedules(orgId, profileId, signal);

  return { queryKey, queryFn, enabled: !!(orgId && profileId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSchedules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof getSchedules>>>;
export type GetSchedulesQueryError = ErrorType<ErrorProblemDetails>;

export function useGetSchedules<
  TData = Awaited<ReturnType<typeof getSchedules>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedules>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchedules>>,
          TError,
          Awaited<ReturnType<typeof getSchedules>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSchedules<
  TData = Awaited<ReturnType<typeof getSchedules>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedules>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchedules>>,
          TError,
          Awaited<ReturnType<typeof getSchedules>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSchedules<
  TData = Awaited<ReturnType<typeof getSchedules>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedules>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List schedules
 */

export function useGetSchedules<
  TData = Awaited<ReturnType<typeof getSchedules>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedules>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSchedulesQueryOptions(orgId, profileId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deletes a specific schedule by its ID. Requires Admin or Operator role.
 * @summary Delete schedule
 */
export const deleteSchedulesById = (orgId: string, profileId: string, scheduleId: string) => {
  return instance<Void>({
    url: `/orgs/${orgId}/profiles/${profileId}/schedules/${scheduleId}`,
    method: 'DELETE',
  });
};

export const getDeleteSchedulesByIdMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSchedulesById>>,
    TError,
    { orgId: string; profileId: string; scheduleId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSchedulesById>>,
  TError,
  { orgId: string; profileId: string; scheduleId: string },
  TContext
> => {
  const mutationKey = ['deleteSchedulesById'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSchedulesById>>,
    { orgId: string; profileId: string; scheduleId: string }
  > = (props) => {
    const { orgId, profileId, scheduleId } = props ?? {};

    return deleteSchedulesById(orgId, profileId, scheduleId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSchedulesByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSchedulesById>>
>;

export type DeleteSchedulesByIdMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Delete schedule
 */
export const useDeleteSchedulesById = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSchedulesById>>,
      TError,
      { orgId: string; profileId: string; scheduleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSchedulesById>>,
  TError,
  { orgId: string; profileId: string; scheduleId: string },
  TContext
> => {
  const mutationOptions = getDeleteSchedulesByIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Triggers a manual sync for all enabled source tables in the profile. Requires Admin or Operator role.
 * @summary Trigger profile sync
 */
export const postProfileSync = (
  orgId: string,
  profileId: string,
  syncRequest: SyncRequest,
  signal?: AbortSignal
) => {
  return instance<PostProfileSync200>({
    url: `/orgs/${orgId}/profiles/${profileId}/sync`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: syncRequest,
    signal,
  });
};

export const getPostProfileSyncMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postProfileSync>>,
    TError,
    { orgId: string; profileId: string; data: SyncRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postProfileSync>>,
  TError,
  { orgId: string; profileId: string; data: SyncRequest },
  TContext
> => {
  const mutationKey = ['postProfileSync'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postProfileSync>>,
    { orgId: string; profileId: string; data: SyncRequest }
  > = (props) => {
    const { orgId, profileId, data } = props ?? {};

    return postProfileSync(orgId, profileId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostProfileSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof postProfileSync>>
>;
export type PostProfileSyncMutationBody = SyncRequest;
export type PostProfileSyncMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Trigger profile sync
 */
export const usePostProfileSync = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postProfileSync>>,
      TError,
      { orgId: string; profileId: string; data: SyncRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postProfileSync>>,
  TError,
  { orgId: string; profileId: string; data: SyncRequest },
  TContext
> => {
  const mutationOptions = getPostProfileSyncMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves paginated run metadata for a specific source table.
 * @summary Get run metadata
 */
export const getRunMetadata = (
  orgId: string,
  profileId: string,
  sourceTableId: string,
  getRunMetadataRequest: GetRunMetadataRequest,
  signal?: AbortSignal
) => {
  return instance<RunMetadataPaginatedResult>({
    url: `/orgs/${orgId}/profiles/${profileId}/sourcetables/${sourceTableId}/runs/list`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: getRunMetadataRequest,
    signal,
  });
};

export const getGetRunMetadataMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getRunMetadata>>,
    TError,
    { orgId: string; profileId: string; sourceTableId: string; data: GetRunMetadataRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getRunMetadata>>,
  TError,
  { orgId: string; profileId: string; sourceTableId: string; data: GetRunMetadataRequest },
  TContext
> => {
  const mutationKey = ['getRunMetadata'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getRunMetadata>>,
    { orgId: string; profileId: string; sourceTableId: string; data: GetRunMetadataRequest }
  > = (props) => {
    const { orgId, profileId, sourceTableId, data } = props ?? {};

    return getRunMetadata(orgId, profileId, sourceTableId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetRunMetadataMutationResult = NonNullable<Awaited<ReturnType<typeof getRunMetadata>>>;
export type GetRunMetadataMutationBody = GetRunMetadataRequest;
export type GetRunMetadataMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Get run metadata
 */
export const useGetRunMetadata = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getRunMetadata>>,
      TError,
      { orgId: string; profileId: string; sourceTableId: string; data: GetRunMetadataRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getRunMetadata>>,
  TError,
  { orgId: string; profileId: string; sourceTableId: string; data: GetRunMetadataRequest },
  TContext
> => {
  const mutationOptions = getGetRunMetadataMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Adds a new data source to a profile. Requires Admin or Operator role.
 * @summary Add data source
 */
export const postSources = (
  orgId: string,
  profileId: string,
  addSourceRequest: AddSourceRequest,
  signal?: AbortSignal
) => {
  return instance<AddSourceResponse>({
    url: `/orgs/${orgId}/profiles/${profileId}/sources`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addSourceRequest,
    signal,
  });
};

export const getPostSourcesMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSources>>,
    TError,
    { orgId: string; profileId: string; data: AddSourceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSources>>,
  TError,
  { orgId: string; profileId: string; data: AddSourceRequest },
  TContext
> => {
  const mutationKey = ['postSources'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSources>>,
    { orgId: string; profileId: string; data: AddSourceRequest }
  > = (props) => {
    const { orgId, profileId, data } = props ?? {};

    return postSources(orgId, profileId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSourcesMutationResult = NonNullable<Awaited<ReturnType<typeof postSources>>>;
export type PostSourcesMutationBody = AddSourceRequest;
export type PostSourcesMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Add data source
 */
export const usePostSources = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSources>>,
      TError,
      { orgId: string; profileId: string; data: AddSourceRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postSources>>,
  TError,
  { orgId: string; profileId: string; data: AddSourceRequest },
  TContext
> => {
  const mutationOptions = getPostSourcesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates an existing data source configuration. Requires Admin or Operator role.
 * @summary Update data source
 */
export const putSources = (
  orgId: string,
  profileId: string,
  sourceId: string,
  updateSourceRequest: UpdateSourceRequest
) => {
  return instance<PutSources200>({
    url: `/orgs/${orgId}/profiles/${profileId}/sources/${sourceId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateSourceRequest,
  });
};

export const getPutSourcesMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSources>>,
    TError,
    { orgId: string; profileId: string; sourceId: string; data: UpdateSourceRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSources>>,
  TError,
  { orgId: string; profileId: string; sourceId: string; data: UpdateSourceRequest },
  TContext
> => {
  const mutationKey = ['putSources'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSources>>,
    { orgId: string; profileId: string; sourceId: string; data: UpdateSourceRequest }
  > = (props) => {
    const { orgId, profileId, sourceId, data } = props ?? {};

    return putSources(orgId, profileId, sourceId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutSourcesMutationResult = NonNullable<Awaited<ReturnType<typeof putSources>>>;
export type PutSourcesMutationBody = UpdateSourceRequest;
export type PutSourcesMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Update data source
 */
export const usePutSources = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSources>>,
      TError,
      { orgId: string; profileId: string; sourceId: string; data: UpdateSourceRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putSources>>,
  TError,
  { orgId: string; profileId: string; sourceId: string; data: UpdateSourceRequest },
  TContext
> => {
  const mutationOptions = getPutSourcesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves detailed information about a specific data source by its ID.
 * @summary Get source by ID
 */
export const getSourcesById = (
  orgId: string,
  profileId: string,
  sourceId: string,
  signal?: AbortSignal
) => {
  return instance<SourceDto>({
    url: `/orgs/${orgId}/profiles/${profileId}/sources/${sourceId}`,
    method: 'GET',
    signal,
  });
};

export const getGetSourcesByIdQueryKey = (
  orgId?: string,
  profileId?: string,
  sourceId?: string
) => {
  return [`/orgs/${orgId}/profiles/${profileId}/sources/${sourceId}`] as const;
};

export const getGetSourcesByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getSourcesById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSourcesById>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSourcesByIdQueryKey(orgId, profileId, sourceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSourcesById>>> = ({ signal }) =>
    getSourcesById(orgId, profileId, sourceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && profileId && sourceId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getSourcesById>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetSourcesByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSourcesById>>>;
export type GetSourcesByIdQueryError = ErrorType<ErrorProblemDetails>;

export function useGetSourcesById<
  TData = Awaited<ReturnType<typeof getSourcesById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSourcesById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSourcesById>>,
          TError,
          Awaited<ReturnType<typeof getSourcesById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSourcesById<
  TData = Awaited<ReturnType<typeof getSourcesById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSourcesById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSourcesById>>,
          TError,
          Awaited<ReturnType<typeof getSourcesById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSourcesById<
  TData = Awaited<ReturnType<typeof getSourcesById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSourcesById>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get source by ID
 */

export function useGetSourcesById<
  TData = Awaited<ReturnType<typeof getSourcesById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSourcesById>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSourcesByIdQueryOptions(orgId, profileId, sourceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Validates Dataverse connection parameters without persisting credentials. Used during source creation to verify credentials are correct before saving. Returns structured error codes (ServiceErrorCode Dataverse values 1310-1325) for specific error conditions like invalid credentials (2003-2004), DNS errors (2001), or permission issues (2011-2012).
 * @summary Test new source connection
 */
export const postSourcesTestConnection = (
  orgId: string,
  profileId: string,
  testDataverseConnectionRequest: TestDataverseConnectionRequest,
  signal?: AbortSignal
) => {
  return instance<ConnectionTestResponse>({
    url: `/orgs/${orgId}/profiles/${profileId}/sources/test-connection`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: testDataverseConnectionRequest,
    signal,
  });
};

export const getPostSourcesTestConnectionMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSourcesTestConnection>>,
    TError,
    { orgId: string; profileId: string; data: TestDataverseConnectionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSourcesTestConnection>>,
  TError,
  { orgId: string; profileId: string; data: TestDataverseConnectionRequest },
  TContext
> => {
  const mutationKey = ['postSourcesTestConnection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSourcesTestConnection>>,
    { orgId: string; profileId: string; data: TestDataverseConnectionRequest }
  > = (props) => {
    const { orgId, profileId, data } = props ?? {};

    return postSourcesTestConnection(orgId, profileId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSourcesTestConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSourcesTestConnection>>
>;
export type PostSourcesTestConnectionMutationBody = TestDataverseConnectionRequest;
export type PostSourcesTestConnectionMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Test new source connection
 */
export const usePostSourcesTestConnection = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSourcesTestConnection>>,
      TError,
      { orgId: string; profileId: string; data: TestDataverseConnectionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postSourcesTestConnection>>,
  TError,
  { orgId: string; profileId: string; data: TestDataverseConnectionRequest },
  TContext
> => {
  const mutationOptions = getPostSourcesTestConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Validates that an existing source's connection is still valid using stored credentials. Used to diagnose connectivity issues or verify credentials after rotation. Returns structured error codes (ServiceErrorCode Dataverse values 1310-1325) for specific error conditions.
 * @summary Test existing source connection
 */
export const postSourcesByIdTestConnection = (
  orgId: string,
  profileId: string,
  sourceId: string,
  signal?: AbortSignal
) => {
  return instance<ConnectionTestResponse>({
    url: `/orgs/${orgId}/profiles/${profileId}/sources/${sourceId}/test-connection`,
    method: 'POST',
    signal,
  });
};

export const getPostSourcesByIdTestConnectionMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSourcesByIdTestConnection>>,
    TError,
    { orgId: string; profileId: string; sourceId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSourcesByIdTestConnection>>,
  TError,
  { orgId: string; profileId: string; sourceId: string },
  TContext
> => {
  const mutationKey = ['postSourcesByIdTestConnection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSourcesByIdTestConnection>>,
    { orgId: string; profileId: string; sourceId: string }
  > = (props) => {
    const { orgId, profileId, sourceId } = props ?? {};

    return postSourcesByIdTestConnection(orgId, profileId, sourceId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSourcesByIdTestConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSourcesByIdTestConnection>>
>;

export type PostSourcesByIdTestConnectionMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Test existing source connection
 */
export const usePostSourcesByIdTestConnection = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSourcesByIdTestConnection>>,
      TError,
      { orgId: string; profileId: string; sourceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postSourcesByIdTestConnection>>,
  TError,
  { orgId: string; profileId: string; sourceId: string },
  TContext
> => {
  const mutationOptions = getPostSourcesByIdTestConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Validates Business Central credentials and returns accessible companies. Used during source creation to verify credentials and let the user select a company before saving.
 * @summary Test new BC source connection
 */
export const postSourcesBcTestConnection = (
  orgId: string,
  profileId: string,
  testBcConnectionRequest: TestBcConnectionRequest,
  signal?: AbortSignal
) => {
  return instance<TestBcConnectionResponse>({
    url: `/orgs/${orgId}/profiles/${profileId}/sources/bc/test-connection`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: testBcConnectionRequest,
    signal,
  });
};

export const getPostSourcesBcTestConnectionMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSourcesBcTestConnection>>,
    TError,
    { orgId: string; profileId: string; data: TestBcConnectionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSourcesBcTestConnection>>,
  TError,
  { orgId: string; profileId: string; data: TestBcConnectionRequest },
  TContext
> => {
  const mutationKey = ['postSourcesBcTestConnection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSourcesBcTestConnection>>,
    { orgId: string; profileId: string; data: TestBcConnectionRequest }
  > = (props) => {
    const { orgId, profileId, data } = props ?? {};

    return postSourcesBcTestConnection(orgId, profileId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSourcesBcTestConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSourcesBcTestConnection>>
>;
export type PostSourcesBcTestConnectionMutationBody = TestBcConnectionRequest;
export type PostSourcesBcTestConnectionMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Test new BC source connection
 */
export const usePostSourcesBcTestConnection = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSourcesBcTestConnection>>,
      TError,
      { orgId: string; profileId: string; data: TestBcConnectionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postSourcesBcTestConnection>>,
  TError,
  { orgId: string; profileId: string; data: TestBcConnectionRequest },
  TContext
> => {
  const mutationOptions = getPostSourcesBcTestConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Validates Salesforce credentials by calling the SObject List endpoint without persisting them. Used during source creation to verify credentials are correct before saving.
 * @summary Test new Salesforce source connection
 */
export const postSourcesSalesforceTestConnection = (
  orgId: string,
  profileId: string,
  testSalesforceConnectionRequest: TestSalesforceConnectionRequest,
  signal?: AbortSignal
) => {
  return instance<ConnectionTestResponse>({
    url: `/orgs/${orgId}/profiles/${profileId}/sources/salesforce/test-connection`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: testSalesforceConnectionRequest,
    signal,
  });
};

export const getPostSourcesSalesforceTestConnectionMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSourcesSalesforceTestConnection>>,
    TError,
    { orgId: string; profileId: string; data: TestSalesforceConnectionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSourcesSalesforceTestConnection>>,
  TError,
  { orgId: string; profileId: string; data: TestSalesforceConnectionRequest },
  TContext
> => {
  const mutationKey = ['postSourcesSalesforceTestConnection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSourcesSalesforceTestConnection>>,
    { orgId: string; profileId: string; data: TestSalesforceConnectionRequest }
  > = (props) => {
    const { orgId, profileId, data } = props ?? {};

    return postSourcesSalesforceTestConnection(orgId, profileId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSourcesSalesforceTestConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSourcesSalesforceTestConnection>>
>;
export type PostSourcesSalesforceTestConnectionMutationBody = TestSalesforceConnectionRequest;
export type PostSourcesSalesforceTestConnectionMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Test new Salesforce source connection
 */
export const usePostSourcesSalesforceTestConnection = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSourcesSalesforceTestConnection>>,
      TError,
      { orgId: string; profileId: string; data: TestSalesforceConnectionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postSourcesSalesforceTestConnection>>,
  TError,
  { orgId: string; profileId: string; data: TestSalesforceConnectionRequest },
  TContext
> => {
  const mutationOptions = getPostSourcesSalesforceTestConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Adds a new table to an existing data source. Requires Admin or Operator role.
 * @summary Add source table
 */
export const postSourceTables = (
  orgId: string,
  profileId: string,
  sourceId: string,
  addSourceTableRequest: AddSourceTableRequest,
  signal?: AbortSignal
) => {
  return instance<AddSourceTableResponse>({
    url: `/orgs/${orgId}/profiles/${profileId}/sources/${sourceId}/tables`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addSourceTableRequest,
    signal,
  });
};

export const getPostSourceTablesMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSourceTables>>,
    TError,
    { orgId: string; profileId: string; sourceId: string; data: AddSourceTableRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSourceTables>>,
  TError,
  { orgId: string; profileId: string; sourceId: string; data: AddSourceTableRequest },
  TContext
> => {
  const mutationKey = ['postSourceTables'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSourceTables>>,
    { orgId: string; profileId: string; sourceId: string; data: AddSourceTableRequest }
  > = (props) => {
    const { orgId, profileId, sourceId, data } = props ?? {};

    return postSourceTables(orgId, profileId, sourceId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSourceTablesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSourceTables>>
>;
export type PostSourceTablesMutationBody = AddSourceTableRequest;
export type PostSourceTablesMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Add source table
 */
export const usePostSourceTables = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSourceTables>>,
      TError,
      { orgId: string; profileId: string; sourceId: string; data: AddSourceTableRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postSourceTables>>,
  TError,
  { orgId: string; profileId: string; sourceId: string; data: AddSourceTableRequest },
  TContext
> => {
  const mutationOptions = getPostSourceTablesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves a specific source table by its ID.
 * @summary Get source table
 */
export const getSourceTable = (
  orgId: string,
  profileId: string,
  sourceId: string,
  sourceTableId: string,
  signal?: AbortSignal
) => {
  return instance<SourceTableDto>({
    url: `/orgs/${orgId}/profiles/${profileId}/sources/${sourceId}/tables/${sourceTableId}`,
    method: 'GET',
    signal,
  });
};

export const getGetSourceTableQueryKey = (
  orgId?: string,
  profileId?: string,
  sourceId?: string,
  sourceTableId?: string
) => {
  return [
    `/orgs/${orgId}/profiles/${profileId}/sources/${sourceId}/tables/${sourceTableId}`,
  ] as const;
};

export const getGetSourceTableQueryOptions = <
  TData = Awaited<ReturnType<typeof getSourceTable>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  sourceTableId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSourceTable>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSourceTableQueryKey(orgId, profileId, sourceId, sourceTableId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSourceTable>>> = ({ signal }) =>
    getSourceTable(orgId, profileId, sourceId, sourceTableId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && profileId && sourceId && sourceTableId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getSourceTable>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetSourceTableQueryResult = NonNullable<Awaited<ReturnType<typeof getSourceTable>>>;
export type GetSourceTableQueryError = ErrorType<ErrorProblemDetails>;

export function useGetSourceTable<
  TData = Awaited<ReturnType<typeof getSourceTable>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  sourceTableId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSourceTable>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSourceTable>>,
          TError,
          Awaited<ReturnType<typeof getSourceTable>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSourceTable<
  TData = Awaited<ReturnType<typeof getSourceTable>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  sourceTableId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSourceTable>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSourceTable>>,
          TError,
          Awaited<ReturnType<typeof getSourceTable>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSourceTable<
  TData = Awaited<ReturnType<typeof getSourceTable>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  sourceTableId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSourceTable>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get source table
 */

export function useGetSourceTable<
  TData = Awaited<ReturnType<typeof getSourceTable>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  sourceTableId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSourceTable>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSourceTableQueryOptions(
    orgId,
    profileId,
    sourceId,
    sourceTableId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates the enabled/disabled state of a source table. Requires Admin or Operator role.
 * @summary Update source table state
 */
export const putSourceTableState = (
  orgId: string,
  profileId: string,
  sourceId: string,
  sourceTableId: string,
  updateSourceTableStateRequest: UpdateSourceTableStateRequest
) => {
  return instance<PutSourceTableState200>({
    url: `/orgs/${orgId}/profiles/${profileId}/sources/${sourceId}/tables/${sourceTableId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateSourceTableStateRequest,
  });
};

export const getPutSourceTableStateMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSourceTableState>>,
    TError,
    {
      orgId: string;
      profileId: string;
      sourceId: string;
      sourceTableId: string;
      data: UpdateSourceTableStateRequest;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSourceTableState>>,
  TError,
  {
    orgId: string;
    profileId: string;
    sourceId: string;
    sourceTableId: string;
    data: UpdateSourceTableStateRequest;
  },
  TContext
> => {
  const mutationKey = ['putSourceTableState'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSourceTableState>>,
    {
      orgId: string;
      profileId: string;
      sourceId: string;
      sourceTableId: string;
      data: UpdateSourceTableStateRequest;
    }
  > = (props) => {
    const { orgId, profileId, sourceId, sourceTableId, data } = props ?? {};

    return putSourceTableState(orgId, profileId, sourceId, sourceTableId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutSourceTableStateMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSourceTableState>>
>;
export type PutSourceTableStateMutationBody = UpdateSourceTableStateRequest;
export type PutSourceTableStateMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Update source table state
 */
export const usePutSourceTableState = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSourceTableState>>,
      TError,
      {
        orgId: string;
        profileId: string;
        sourceId: string;
        sourceTableId: string;
        data: UpdateSourceTableStateRequest;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putSourceTableState>>,
  TError,
  {
    orgId: string;
    profileId: string;
    sourceId: string;
    sourceTableId: string;
    data: UpdateSourceTableStateRequest;
  },
  TContext
> => {
  const mutationOptions = getPutSourceTableStateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a specific source table. Requires Admin or Operator role.
 * @summary Delete source table
 */
export const deleteSourceTablesById = (
  orgId: string,
  profileId: string,
  sourceId: string,
  sourceTableId: string
) => {
  return instance<DeleteSourceTablesById200>({
    url: `/orgs/${orgId}/profiles/${profileId}/sources/${sourceId}/tables/${sourceTableId}`,
    method: 'DELETE',
  });
};

export const getDeleteSourceTablesByIdMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSourceTablesById>>,
    TError,
    { orgId: string; profileId: string; sourceId: string; sourceTableId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSourceTablesById>>,
  TError,
  { orgId: string; profileId: string; sourceId: string; sourceTableId: string },
  TContext
> => {
  const mutationKey = ['deleteSourceTablesById'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSourceTablesById>>,
    { orgId: string; profileId: string; sourceId: string; sourceTableId: string }
  > = (props) => {
    const { orgId, profileId, sourceId, sourceTableId } = props ?? {};

    return deleteSourceTablesById(orgId, profileId, sourceId, sourceTableId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSourceTablesByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSourceTablesById>>
>;

export type DeleteSourceTablesByIdMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Delete source table
 */
export const useDeleteSourceTablesById = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSourceTablesById>>,
      TError,
      { orgId: string; profileId: string; sourceId: string; sourceTableId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSourceTablesById>>,
  TError,
  { orgId: string; profileId: string; sourceId: string; sourceTableId: string },
  TContext
> => {
  const mutationOptions = getDeleteSourceTablesByIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves all tables associated with a specific data source.
 * @summary List source tables
 */
export const getSourceTables = (
  orgId: string,
  profileId: string,
  sourceId: string,
  listSourceTablesRequest: ListSourceTablesRequest,
  signal?: AbortSignal
) => {
  return instance<PaginatedResultSourceTableDto>({
    url: `/orgs/${orgId}/profiles/${profileId}/sources/${sourceId}/tables/list`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: listSourceTablesRequest,
    signal,
  });
};

export const getGetSourceTablesMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getSourceTables>>,
    TError,
    { orgId: string; profileId: string; sourceId: string; data: ListSourceTablesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getSourceTables>>,
  TError,
  { orgId: string; profileId: string; sourceId: string; data: ListSourceTablesRequest },
  TContext
> => {
  const mutationKey = ['getSourceTables'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getSourceTables>>,
    { orgId: string; profileId: string; sourceId: string; data: ListSourceTablesRequest }
  > = (props) => {
    const { orgId, profileId, sourceId, data } = props ?? {};

    return getSourceTables(orgId, profileId, sourceId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetSourceTablesMutationResult = NonNullable<
  Awaited<ReturnType<typeof getSourceTables>>
>;
export type GetSourceTablesMutationBody = ListSourceTablesRequest;
export type GetSourceTablesMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary List source tables
 */
export const useGetSourceTables = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getSourceTables>>,
      TError,
      { orgId: string; profileId: string; sourceId: string; data: ListSourceTablesRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getSourceTables>>,
  TError,
  { orgId: string; profileId: string; sourceId: string; data: ListSourceTablesRequest },
  TContext
> => {
  const mutationOptions = getGetSourceTablesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves all tables available in the source system that haven't been configured yet.
 * @summary Get available source tables
 */
export const getAvailableSourceTables = (
  orgId: string,
  profileId: string,
  sourceId: string,
  signal?: AbortSignal
) => {
  return instance<AvailableSourceTableDto[]>({
    url: `/orgs/${orgId}/profiles/${profileId}/sources/${sourceId}/tables/available`,
    method: 'GET',
    signal,
  });
};

export const getGetAvailableSourceTablesQueryKey = (
  orgId?: string,
  profileId?: string,
  sourceId?: string
) => {
  return [`/orgs/${orgId}/profiles/${profileId}/sources/${sourceId}/tables/available`] as const;
};

export const getGetAvailableSourceTablesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailableSourceTables>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAvailableSourceTables>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAvailableSourceTablesQueryKey(orgId, profileId, sourceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableSourceTables>>> = ({
    signal,
  }) => getAvailableSourceTables(orgId, profileId, sourceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && profileId && sourceId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAvailableSourceTables>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetAvailableSourceTablesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailableSourceTables>>
>;
export type GetAvailableSourceTablesQueryError = ErrorType<ErrorProblemDetails>;

export function useGetAvailableSourceTables<
  TData = Awaited<ReturnType<typeof getAvailableSourceTables>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAvailableSourceTables>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableSourceTables>>,
          TError,
          Awaited<ReturnType<typeof getAvailableSourceTables>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAvailableSourceTables<
  TData = Awaited<ReturnType<typeof getAvailableSourceTables>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAvailableSourceTables>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableSourceTables>>,
          TError,
          Awaited<ReturnType<typeof getAvailableSourceTables>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAvailableSourceTables<
  TData = Awaited<ReturnType<typeof getAvailableSourceTables>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAvailableSourceTables>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get available source tables
 */

export function useGetAvailableSourceTables<
  TData = Awaited<ReturnType<typeof getAvailableSourceTables>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAvailableSourceTables>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAvailableSourceTablesQueryOptions(orgId, profileId, sourceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTargetSchema = (
  orgId: string,
  profileId: string,
  sourceId: string,
  sourceTableId: string,
  signal?: AbortSignal
) => {
  return instance<TargetSchemaResponse>({
    url: `/orgs/${orgId}/profiles/${profileId}/sources/${sourceId}/tables/${sourceTableId}/target-schema`,
    method: 'GET',
    signal,
  });
};

export const getGetTargetSchemaQueryKey = (
  orgId?: string,
  profileId?: string,
  sourceId?: string,
  sourceTableId?: string
) => {
  return [
    `/orgs/${orgId}/profiles/${profileId}/sources/${sourceId}/tables/${sourceTableId}/target-schema`,
  ] as const;
};

export const getGetTargetSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof getTargetSchema>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  sourceTableId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetSchema>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTargetSchemaQueryKey(orgId, profileId, sourceId, sourceTableId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTargetSchema>>> = ({ signal }) =>
    getTargetSchema(orgId, profileId, sourceId, sourceTableId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && profileId && sourceId && sourceTableId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTargetSchema>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetTargetSchemaQueryResult = NonNullable<Awaited<ReturnType<typeof getTargetSchema>>>;
export type GetTargetSchemaQueryError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Get target schema
 */
export function useGetTargetSchema<
  TData = Awaited<ReturnType<typeof getTargetSchema>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  sourceId: string,
  sourceTableId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetSchema>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTargetSchemaQueryOptions(
    orgId,
    profileId,
    sourceId,
    sourceTableId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Triggers a manual sync for a specific source table. Requires Admin or Operator role.
 * @summary Trigger source table sync
 */
export const postSourceTableSync = (
  orgId: string,
  profileId: string,
  sourceId: string,
  sourceTableId: string,
  syncRequest: SyncRequest,
  signal?: AbortSignal
) => {
  return instance<PostSourceTableSync200>({
    url: `/orgs/${orgId}/profiles/${profileId}/sources/${sourceId}/sourcetables/${sourceTableId}/sync`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: syncRequest,
    signal,
  });
};

export const getPostSourceTableSyncMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSourceTableSync>>,
    TError,
    {
      orgId: string;
      profileId: string;
      sourceId: string;
      sourceTableId: string;
      data: SyncRequest;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSourceTableSync>>,
  TError,
  { orgId: string; profileId: string; sourceId: string; sourceTableId: string; data: SyncRequest },
  TContext
> => {
  const mutationKey = ['postSourceTableSync'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSourceTableSync>>,
    { orgId: string; profileId: string; sourceId: string; sourceTableId: string; data: SyncRequest }
  > = (props) => {
    const { orgId, profileId, sourceId, sourceTableId, data } = props ?? {};

    return postSourceTableSync(orgId, profileId, sourceId, sourceTableId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSourceTableSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSourceTableSync>>
>;
export type PostSourceTableSyncMutationBody = SyncRequest;
export type PostSourceTableSyncMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Trigger source table sync
 */
export const usePostSourceTableSync = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSourceTableSync>>,
      TError,
      {
        orgId: string;
        profileId: string;
        sourceId: string;
        sourceTableId: string;
        data: SyncRequest;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postSourceTableSync>>,
  TError,
  { orgId: string; profileId: string; sourceId: string; sourceTableId: string; data: SyncRequest },
  TContext
> => {
  const mutationOptions = getPostSourceTableSyncMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Cancels a scheduled or in-progress run. Requires Admin or Operator role.
 * @summary Cancel run
 */
export const postCancelRun = (
  orgId: string,
  profileId: string,
  sourceTableId: string,
  runId: string,
  signal?: AbortSignal
) => {
  return instance<SuccessResponse>({
    url: `/orgs/${orgId}/profiles/${profileId}/sourcetables/${sourceTableId}/runs/${runId}/cancel`,
    method: 'POST',
    signal,
  });
};

export const getPostCancelRunMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCancelRun>>,
    TError,
    { orgId: string; profileId: string; sourceTableId: string; runId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCancelRun>>,
  TError,
  { orgId: string; profileId: string; sourceTableId: string; runId: string },
  TContext
> => {
  const mutationKey = ['postCancelRun'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCancelRun>>,
    { orgId: string; profileId: string; sourceTableId: string; runId: string }
  > = (props) => {
    const { orgId, profileId, sourceTableId, runId } = props ?? {};

    return postCancelRun(orgId, profileId, sourceTableId, runId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCancelRunMutationResult = NonNullable<Awaited<ReturnType<typeof postCancelRun>>>;

export type PostCancelRunMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Cancel run
 */
export const usePostCancelRun = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCancelRun>>,
      TError,
      { orgId: string; profileId: string; sourceTableId: string; runId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postCancelRun>>,
  TError,
  { orgId: string; profileId: string; sourceTableId: string; runId: string },
  TContext
> => {
  const mutationOptions = getPostCancelRunMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Adds a new data target to a profile. Requires Admin or Operator role.
 * @summary Add data target
 */
export const postTargets = (
  orgId: string,
  profileId: string,
  addTargetRequest: AddTargetRequest,
  signal?: AbortSignal
) => {
  return instance<AddTargetResponse>({
    url: `/orgs/${orgId}/profiles/${profileId}/targets`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addTargetRequest,
    signal,
  });
};

export const getPostTargetsMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTargets>>,
    TError,
    { orgId: string; profileId: string; data: AddTargetRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTargets>>,
  TError,
  { orgId: string; profileId: string; data: AddTargetRequest },
  TContext
> => {
  const mutationKey = ['postTargets'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTargets>>,
    { orgId: string; profileId: string; data: AddTargetRequest }
  > = (props) => {
    const { orgId, profileId, data } = props ?? {};

    return postTargets(orgId, profileId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTargetsMutationResult = NonNullable<Awaited<ReturnType<typeof postTargets>>>;
export type PostTargetsMutationBody = AddTargetRequest;
export type PostTargetsMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Add data target
 */
export const usePostTargets = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTargets>>,
      TError,
      { orgId: string; profileId: string; data: AddTargetRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postTargets>>,
  TError,
  { orgId: string; profileId: string; data: AddTargetRequest },
  TContext
> => {
  const mutationOptions = getPostTargetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves detailed information about a specific data target by its ID.
 * @summary Get target by ID
 */
export const getTargetsById = (
  orgId: string,
  profileId: string,
  targetId: string,
  signal?: AbortSignal
) => {
  return instance<TargetDto>({
    url: `/orgs/${orgId}/profiles/${profileId}/targets/${targetId}`,
    method: 'GET',
    signal,
  });
};

export const getGetTargetsByIdQueryKey = (
  orgId?: string,
  profileId?: string,
  targetId?: string
) => {
  return [`/orgs/${orgId}/profiles/${profileId}/targets/${targetId}`] as const;
};

export const getGetTargetsByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getTargetsById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  targetId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetsById>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTargetsByIdQueryKey(orgId, profileId, targetId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTargetsById>>> = ({ signal }) =>
    getTargetsById(orgId, profileId, targetId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && profileId && targetId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTargetsById>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetTargetsByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getTargetsById>>>;
export type GetTargetsByIdQueryError = ErrorType<ErrorProblemDetails>;

export function useGetTargetsById<
  TData = Awaited<ReturnType<typeof getTargetsById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  targetId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetsById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTargetsById>>,
          TError,
          Awaited<ReturnType<typeof getTargetsById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTargetsById<
  TData = Awaited<ReturnType<typeof getTargetsById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  targetId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetsById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTargetsById>>,
          TError,
          Awaited<ReturnType<typeof getTargetsById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTargetsById<
  TData = Awaited<ReturnType<typeof getTargetsById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  targetId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetsById>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get target by ID
 */

export function useGetTargetsById<
  TData = Awaited<ReturnType<typeof getTargetsById>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  profileId: string,
  targetId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargetsById>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTargetsByIdQueryOptions(orgId, profileId, targetId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates a target's authentication credentials (TenantId, ClientId, ClientSecret). Connection is tested before saving; if the test fails, the update is rejected. Requires Admin or Operator role.
 * @summary Update target credentials
 */
export const patchTargetsById = (
  orgId: string,
  profileId: string,
  targetId: string,
  updateTargetRequest: UpdateTargetRequest
) => {
  return instance<PatchTargetsById200>({
    url: `/orgs/${orgId}/profiles/${profileId}/targets/${targetId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateTargetRequest,
  });
};

export const getPatchTargetsByIdMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchTargetsById>>,
    TError,
    { orgId: string; profileId: string; targetId: string; data: UpdateTargetRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchTargetsById>>,
  TError,
  { orgId: string; profileId: string; targetId: string; data: UpdateTargetRequest },
  TContext
> => {
  const mutationKey = ['patchTargetsById'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchTargetsById>>,
    { orgId: string; profileId: string; targetId: string; data: UpdateTargetRequest }
  > = (props) => {
    const { orgId, profileId, targetId, data } = props ?? {};

    return patchTargetsById(orgId, profileId, targetId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchTargetsByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchTargetsById>>
>;
export type PatchTargetsByIdMutationBody = UpdateTargetRequest;
export type PatchTargetsByIdMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Update target credentials
 */
export const usePatchTargetsById = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchTargetsById>>,
      TError,
      { orgId: string; profileId: string; targetId: string; data: UpdateTargetRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchTargetsById>>,
  TError,
  { orgId: string; profileId: string; targetId: string; data: UpdateTargetRequest },
  TContext
> => {
  const mutationOptions = getPatchTargetsByIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Validates Azure SQL connection parameters without persisting credentials. Used during target creation to verify credentials are correct before saving.
 * @summary Test new target connection
 */
export const postTargetsTestConnection = (
  orgId: string,
  profileId: string,
  testAzureSqlConnectionRequest: TestAzureSqlConnectionRequest,
  signal?: AbortSignal
) => {
  return instance<ConnectionTestResponse>({
    url: `/orgs/${orgId}/profiles/${profileId}/targets/test-connection`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: testAzureSqlConnectionRequest,
    signal,
  });
};

export const getPostTargetsTestConnectionMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTargetsTestConnection>>,
    TError,
    { orgId: string; profileId: string; data: TestAzureSqlConnectionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTargetsTestConnection>>,
  TError,
  { orgId: string; profileId: string; data: TestAzureSqlConnectionRequest },
  TContext
> => {
  const mutationKey = ['postTargetsTestConnection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTargetsTestConnection>>,
    { orgId: string; profileId: string; data: TestAzureSqlConnectionRequest }
  > = (props) => {
    const { orgId, profileId, data } = props ?? {};

    return postTargetsTestConnection(orgId, profileId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTargetsTestConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTargetsTestConnection>>
>;
export type PostTargetsTestConnectionMutationBody = TestAzureSqlConnectionRequest;
export type PostTargetsTestConnectionMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Test new target connection
 */
export const usePostTargetsTestConnection = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTargetsTestConnection>>,
      TError,
      { orgId: string; profileId: string; data: TestAzureSqlConnectionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postTargetsTestConnection>>,
  TError,
  { orgId: string; profileId: string; data: TestAzureSqlConnectionRequest },
  TContext
> => {
  const mutationOptions = getPostTargetsTestConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Validates that an existing target's connection is still valid using stored credentials. Used to diagnose connectivity issues or verify credentials after rotation.
 * @summary Test existing target connection
 */
export const postTargetsByIdTestConnection = (
  orgId: string,
  profileId: string,
  targetId: string,
  signal?: AbortSignal
) => {
  return instance<ConnectionTestResponse>({
    url: `/orgs/${orgId}/profiles/${profileId}/targets/${targetId}/test-connection`,
    method: 'POST',
    signal,
  });
};

export const getPostTargetsByIdTestConnectionMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTargetsByIdTestConnection>>,
    TError,
    { orgId: string; profileId: string; targetId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTargetsByIdTestConnection>>,
  TError,
  { orgId: string; profileId: string; targetId: string },
  TContext
> => {
  const mutationKey = ['postTargetsByIdTestConnection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTargetsByIdTestConnection>>,
    { orgId: string; profileId: string; targetId: string }
  > = (props) => {
    const { orgId, profileId, targetId } = props ?? {};

    return postTargetsByIdTestConnection(orgId, profileId, targetId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTargetsByIdTestConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTargetsByIdTestConnection>>
>;

export type PostTargetsByIdTestConnectionMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Test existing target connection
 */
export const usePostTargetsByIdTestConnection = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTargetsByIdTestConnection>>,
      TError,
      { orgId: string; profileId: string; targetId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postTargetsByIdTestConnection>>,
  TError,
  { orgId: string; profileId: string; targetId: string },
  TContext
> => {
  const mutationOptions = getPostTargetsByIdTestConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns the organization's current partner, or null when it has none.
 * @summary Get current partner
 */
export const getSupportPartner = (orgId: string, signal?: AbortSignal) => {
  return instance<SupportPartnerDto>({
    url: `/orgs/${orgId}/support/partner`,
    method: 'GET',
    signal,
  });
};

export const getGetSupportPartnerQueryKey = (orgId?: string) => {
  return [`/orgs/${orgId}/support/partner`] as const;
};

export const getGetSupportPartnerQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupportPartner>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportPartner>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSupportPartnerQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportPartner>>> = ({ signal }) =>
    getSupportPartner(orgId, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSupportPartner>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSupportPartnerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSupportPartner>>
>;
export type GetSupportPartnerQueryError = ErrorType<ErrorProblemDetails>;

export function useGetSupportPartner<
  TData = Awaited<ReturnType<typeof getSupportPartner>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportPartner>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportPartner>>,
          TError,
          Awaited<ReturnType<typeof getSupportPartner>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSupportPartner<
  TData = Awaited<ReturnType<typeof getSupportPartner>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportPartner>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportPartner>>,
          TError,
          Awaited<ReturnType<typeof getSupportPartner>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSupportPartner<
  TData = Awaited<ReturnType<typeof getSupportPartner>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportPartner>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get current partner
 */

export function useGetSupportPartner<
  TData = Awaited<ReturnType<typeof getSupportPartner>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportPartner>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSupportPartnerQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Streams the current partner's logo. Supports ETag / If-None-Match.
 * @summary Get current partner logo
 */
export const getSupportPartnerLogo = (
  orgId: string,
  params?: GetSupportPartnerLogoParams,
  signal?: AbortSignal
) => {
  return instance<Blob>({
    url: `/orgs/${orgId}/support/partner/logo`,
    method: 'GET',
    params,
    responseType: 'blob',
    signal,
  });
};

export const getGetSupportPartnerLogoQueryKey = (
  orgId?: string,
  params?: GetSupportPartnerLogoParams
) => {
  return [`/orgs/${orgId}/support/partner/logo`, ...(params ? [params] : [])] as const;
};

export const getGetSupportPartnerLogoQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupportPartnerLogo>>,
  TError = ErrorType<void | ErrorProblemDetails>,
>(
  orgId: string,
  params?: GetSupportPartnerLogoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportPartnerLogo>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSupportPartnerLogoQueryKey(orgId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportPartnerLogo>>> = ({ signal }) =>
    getSupportPartnerLogo(orgId, params, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSupportPartnerLogo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSupportPartnerLogoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSupportPartnerLogo>>
>;
export type GetSupportPartnerLogoQueryError = ErrorType<void | ErrorProblemDetails>;

export function useGetSupportPartnerLogo<
  TData = Awaited<ReturnType<typeof getSupportPartnerLogo>>,
  TError = ErrorType<void | ErrorProblemDetails>,
>(
  orgId: string,
  params: undefined | GetSupportPartnerLogoParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportPartnerLogo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportPartnerLogo>>,
          TError,
          Awaited<ReturnType<typeof getSupportPartnerLogo>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSupportPartnerLogo<
  TData = Awaited<ReturnType<typeof getSupportPartnerLogo>>,
  TError = ErrorType<void | ErrorProblemDetails>,
>(
  orgId: string,
  params?: GetSupportPartnerLogoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportPartnerLogo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportPartnerLogo>>,
          TError,
          Awaited<ReturnType<typeof getSupportPartnerLogo>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSupportPartnerLogo<
  TData = Awaited<ReturnType<typeof getSupportPartnerLogo>>,
  TError = ErrorType<void | ErrorProblemDetails>,
>(
  orgId: string,
  params?: GetSupportPartnerLogoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportPartnerLogo>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get current partner logo
 */

export function useGetSupportPartnerLogo<
  TData = Awaited<ReturnType<typeof getSupportPartnerLogo>>,
  TError = ErrorType<void | ErrorProblemDetails>,
>(
  orgId: string,
  params?: GetSupportPartnerLogoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportPartnerLogo>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSupportPartnerLogoQueryOptions(orgId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Streams the current partner's dark mode logo, or its normal logo when it has no separate dark mode logo. Supports ETag / If-None-Match.
 * @summary Get current partner dark mode logo
 */
export const getSupportPartnerDarkLogo = (
  orgId: string,
  params?: GetSupportPartnerDarkLogoParams,
  signal?: AbortSignal
) => {
  return instance<Blob>({
    url: `/orgs/${orgId}/support/partner/logo/dark`,
    method: 'GET',
    params,
    responseType: 'blob',
    signal,
  });
};

export const getGetSupportPartnerDarkLogoQueryKey = (
  orgId?: string,
  params?: GetSupportPartnerDarkLogoParams
) => {
  return [`/orgs/${orgId}/support/partner/logo/dark`, ...(params ? [params] : [])] as const;
};

export const getGetSupportPartnerDarkLogoQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>,
  TError = ErrorType<void | ErrorProblemDetails>,
>(
  orgId: string,
  params?: GetSupportPartnerDarkLogoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSupportPartnerDarkLogoQueryKey(orgId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>> = ({
    signal,
  }) => getSupportPartnerDarkLogo(orgId, params, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSupportPartnerDarkLogoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>
>;
export type GetSupportPartnerDarkLogoQueryError = ErrorType<void | ErrorProblemDetails>;

export function useGetSupportPartnerDarkLogo<
  TData = Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>,
  TError = ErrorType<void | ErrorProblemDetails>,
>(
  orgId: string,
  params: undefined | GetSupportPartnerDarkLogoParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>,
          TError,
          Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSupportPartnerDarkLogo<
  TData = Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>,
  TError = ErrorType<void | ErrorProblemDetails>,
>(
  orgId: string,
  params?: GetSupportPartnerDarkLogoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>,
          TError,
          Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSupportPartnerDarkLogo<
  TData = Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>,
  TError = ErrorType<void | ErrorProblemDetails>,
>(
  orgId: string,
  params?: GetSupportPartnerDarkLogoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get current partner dark mode logo
 */

export function useGetSupportPartnerDarkLogo<
  TData = Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>,
  TError = ErrorType<void | ErrorProblemDetails>,
>(
  orgId: string,
  params?: GetSupportPartnerDarkLogoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportPartnerDarkLogo>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSupportPartnerDarkLogoQueryOptions(orgId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Lists every support ticket for the organization, most recently updated first.
 * @summary List support tickets
 */
export const getSupportTickets = (
  orgId: string,
  params?: GetSupportTicketsParams,
  signal?: AbortSignal
) => {
  return instance<PagedResultSupportTicketSummaryDto>({
    url: `/orgs/${orgId}/support/tickets`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetSupportTicketsQueryKey = (orgId?: string, params?: GetSupportTicketsParams) => {
  return [`/orgs/${orgId}/support/tickets`, ...(params ? [params] : [])] as const;
};

export const getGetSupportTicketsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupportTickets>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  params?: GetSupportTicketsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportTickets>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSupportTicketsQueryKey(orgId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportTickets>>> = ({ signal }) =>
    getSupportTickets(orgId, params, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSupportTickets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSupportTicketsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSupportTickets>>
>;
export type GetSupportTicketsQueryError = ErrorType<ErrorProblemDetails>;

export function useGetSupportTickets<
  TData = Awaited<ReturnType<typeof getSupportTickets>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  params: undefined | GetSupportTicketsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportTickets>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportTickets>>,
          TError,
          Awaited<ReturnType<typeof getSupportTickets>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSupportTickets<
  TData = Awaited<ReturnType<typeof getSupportTickets>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  params?: GetSupportTicketsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportTickets>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportTickets>>,
          TError,
          Awaited<ReturnType<typeof getSupportTickets>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSupportTickets<
  TData = Awaited<ReturnType<typeof getSupportTickets>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  params?: GetSupportTicketsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportTickets>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List support tickets
 */

export function useGetSupportTickets<
  TData = Awaited<ReturnType<typeof getSupportTickets>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  params?: GetSupportTicketsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportTickets>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSupportTicketsQueryOptions(orgId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a support ticket. The submitter is always the signed-in user.
 * @summary Create a support ticket
 */
export const postSupportTickets = (
  orgId: string,
  createSupportTicketRequest: CreateSupportTicketRequest,
  signal?: AbortSignal
) => {
  return instance<SupportTicketDetailDto>({
    url: `/orgs/${orgId}/support/tickets`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createSupportTicketRequest,
    signal,
  });
};

export const getPostSupportTicketsMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSupportTickets>>,
    TError,
    { orgId: string; data: CreateSupportTicketRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSupportTickets>>,
  TError,
  { orgId: string; data: CreateSupportTicketRequest },
  TContext
> => {
  const mutationKey = ['postSupportTickets'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSupportTickets>>,
    { orgId: string; data: CreateSupportTicketRequest }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return postSupportTickets(orgId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSupportTicketsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSupportTickets>>
>;
export type PostSupportTicketsMutationBody = CreateSupportTicketRequest;
export type PostSupportTicketsMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Create a support ticket
 */
export const usePostSupportTickets = <TError = ErrorType<ErrorProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSupportTickets>>,
      TError,
      { orgId: string; data: CreateSupportTicketRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postSupportTickets>>,
  TError,
  { orgId: string; data: CreateSupportTicketRequest },
  TContext
> => {
  const mutationOptions = getPostSupportTicketsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns the organization's ticket counts: open, needing the customer's reply, closed and total.
 * @summary Get support ticket counts
 */
export const getSupportTicketCounts = (orgId: string, signal?: AbortSignal) => {
  return instance<SupportTicketCountsDto>({
    url: `/orgs/${orgId}/support/tickets/counts`,
    method: 'GET',
    signal,
  });
};

export const getGetSupportTicketCountsQueryKey = (orgId?: string) => {
  return [`/orgs/${orgId}/support/tickets/counts`] as const;
};

export const getGetSupportTicketCountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupportTicketCounts>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportTicketCounts>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSupportTicketCountsQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportTicketCounts>>> = ({ signal }) =>
    getSupportTicketCounts(orgId, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSupportTicketCounts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSupportTicketCountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSupportTicketCounts>>
>;
export type GetSupportTicketCountsQueryError = ErrorType<ErrorProblemDetails>;

export function useGetSupportTicketCounts<
  TData = Awaited<ReturnType<typeof getSupportTicketCounts>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportTicketCounts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportTicketCounts>>,
          TError,
          Awaited<ReturnType<typeof getSupportTicketCounts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSupportTicketCounts<
  TData = Awaited<ReturnType<typeof getSupportTicketCounts>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportTicketCounts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportTicketCounts>>,
          TError,
          Awaited<ReturnType<typeof getSupportTicketCounts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSupportTicketCounts<
  TData = Awaited<ReturnType<typeof getSupportTicketCounts>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportTicketCounts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get support ticket counts
 */

export function useGetSupportTicketCounts<
  TData = Awaited<ReturnType<typeof getSupportTicketCounts>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportTicketCounts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSupportTicketCountsQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a support ticket with its comments and attachments.
 * @summary Get a support ticket
 */
export const getSupportTicket = (orgId: string, ticketId: string, signal?: AbortSignal) => {
  return instance<SupportTicketDetailDto>({
    url: `/orgs/${orgId}/support/tickets/${ticketId}`,
    method: 'GET',
    signal,
  });
};

export const getGetSupportTicketQueryKey = (orgId?: string, ticketId?: string) => {
  return [`/orgs/${orgId}/support/tickets/${ticketId}`] as const;
};

export const getGetSupportTicketQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupportTicket>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  ticketId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportTicket>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSupportTicketQueryKey(orgId, ticketId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportTicket>>> = ({ signal }) =>
    getSupportTicket(orgId, ticketId, signal);

  return { queryKey, queryFn, enabled: !!(orgId && ticketId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSupportTicket>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSupportTicketQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportTicket>>>;
export type GetSupportTicketQueryError = ErrorType<ErrorProblemDetails>;

export function useGetSupportTicket<
  TData = Awaited<ReturnType<typeof getSupportTicket>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  ticketId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportTicket>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportTicket>>,
          TError,
          Awaited<ReturnType<typeof getSupportTicket>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSupportTicket<
  TData = Awaited<ReturnType<typeof getSupportTicket>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  ticketId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportTicket>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportTicket>>,
          TError,
          Awaited<ReturnType<typeof getSupportTicket>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSupportTicket<
  TData = Awaited<ReturnType<typeof getSupportTicket>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  ticketId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportTicket>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get a support ticket
 */

export function useGetSupportTicket<
  TData = Awaited<ReturnType<typeof getSupportTicket>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  ticketId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportTicket>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSupportTicketQueryOptions(orgId, ticketId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Adds a comment to a support ticket. The author is always the signed-in user.
 * @summary Comment on a support ticket
 */
export const postSupportTicketComments = (
  orgId: string,
  ticketId: string,
  createSupportCommentRequest: CreateSupportCommentRequest,
  signal?: AbortSignal
) => {
  return instance<SupportCommentDto>({
    url: `/orgs/${orgId}/support/tickets/${ticketId}/comments`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createSupportCommentRequest,
    signal,
  });
};

export const getPostSupportTicketCommentsMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSupportTicketComments>>,
    TError,
    { orgId: string; ticketId: string; data: CreateSupportCommentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSupportTicketComments>>,
  TError,
  { orgId: string; ticketId: string; data: CreateSupportCommentRequest },
  TContext
> => {
  const mutationKey = ['postSupportTicketComments'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSupportTicketComments>>,
    { orgId: string; ticketId: string; data: CreateSupportCommentRequest }
  > = (props) => {
    const { orgId, ticketId, data } = props ?? {};

    return postSupportTicketComments(orgId, ticketId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSupportTicketCommentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSupportTicketComments>>
>;
export type PostSupportTicketCommentsMutationBody = CreateSupportCommentRequest;
export type PostSupportTicketCommentsMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Comment on a support ticket
 */
export const usePostSupportTicketComments = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSupportTicketComments>>,
      TError,
      { orgId: string; ticketId: string; data: CreateSupportCommentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postSupportTicketComments>>,
  TError,
  { orgId: string; ticketId: string; data: CreateSupportCommentRequest },
  TContext
> => {
  const mutationOptions = getPostSupportTicketCommentsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Uploads one file (multipart field 'file'). The uploader is always the signed-in user. The file starts with a Pending scan status.
 * @summary Attach a file to a support ticket
 */
export const postSupportTicketAttachments = (
  orgId: string,
  ticketId: string,
  supportAttachmentUploadForm: SupportAttachmentUploadForm,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  if (supportAttachmentUploadForm.file !== undefined) {
    formData.append(`file`, supportAttachmentUploadForm.file);
  }

  return instance<SupportAttachmentDto>({
    url: `/orgs/${orgId}/support/tickets/${ticketId}/attachments`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getPostSupportTicketAttachmentsMutationOptions = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSupportTicketAttachments>>,
    TError,
    { orgId: string; ticketId: string; data: SupportAttachmentUploadForm },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSupportTicketAttachments>>,
  TError,
  { orgId: string; ticketId: string; data: SupportAttachmentUploadForm },
  TContext
> => {
  const mutationKey = ['postSupportTicketAttachments'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSupportTicketAttachments>>,
    { orgId: string; ticketId: string; data: SupportAttachmentUploadForm }
  > = (props) => {
    const { orgId, ticketId, data } = props ?? {};

    return postSupportTicketAttachments(orgId, ticketId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSupportTicketAttachmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSupportTicketAttachments>>
>;
export type PostSupportTicketAttachmentsMutationBody = SupportAttachmentUploadForm;
export type PostSupportTicketAttachmentsMutationError = ErrorType<ErrorProblemDetails>;

/**
 * @summary Attach a file to a support ticket
 */
export const usePostSupportTicketAttachments = <
  TError = ErrorType<ErrorProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSupportTicketAttachments>>,
      TError,
      { orgId: string; ticketId: string; data: SupportAttachmentUploadForm },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postSupportTicketAttachments>>,
  TError,
  { orgId: string; ticketId: string; data: SupportAttachmentUploadForm },
  TContext
> => {
  const mutationOptions = getPostSupportTicketAttachmentsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Streams an attachment. Returns 409 with the scan status while the file is Pending or Unavailable.
 * @summary Download a support ticket attachment
 */
export const getSupportTicketAttachment = (
  orgId: string,
  ticketId: string,
  attachmentId: string,
  signal?: AbortSignal
) => {
  return instance<Blob>({
    url: `/orgs/${orgId}/support/tickets/${ticketId}/attachments/${attachmentId}`,
    method: 'GET',
    responseType: 'blob',
    signal,
  });
};

export const getGetSupportTicketAttachmentQueryKey = (
  orgId?: string,
  ticketId?: string,
  attachmentId?: string
) => {
  return [`/orgs/${orgId}/support/tickets/${ticketId}/attachments/${attachmentId}`] as const;
};

export const getGetSupportTicketAttachmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupportTicketAttachment>>,
  TError = ErrorType<ErrorProblemDetails | SupportAttachmentUnavailableProblemDetails>,
>(
  orgId: string,
  ticketId: string,
  attachmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportTicketAttachment>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSupportTicketAttachmentQueryKey(orgId, ticketId, attachmentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportTicketAttachment>>> = ({
    signal,
  }) => getSupportTicketAttachment(orgId, ticketId, attachmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && ticketId && attachmentId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getSupportTicketAttachment>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetSupportTicketAttachmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSupportTicketAttachment>>
>;
export type GetSupportTicketAttachmentQueryError = ErrorType<
  ErrorProblemDetails | SupportAttachmentUnavailableProblemDetails
>;

export function useGetSupportTicketAttachment<
  TData = Awaited<ReturnType<typeof getSupportTicketAttachment>>,
  TError = ErrorType<ErrorProblemDetails | SupportAttachmentUnavailableProblemDetails>,
>(
  orgId: string,
  ticketId: string,
  attachmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportTicketAttachment>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportTicketAttachment>>,
          TError,
          Awaited<ReturnType<typeof getSupportTicketAttachment>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSupportTicketAttachment<
  TData = Awaited<ReturnType<typeof getSupportTicketAttachment>>,
  TError = ErrorType<ErrorProblemDetails | SupportAttachmentUnavailableProblemDetails>,
>(
  orgId: string,
  ticketId: string,
  attachmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportTicketAttachment>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportTicketAttachment>>,
          TError,
          Awaited<ReturnType<typeof getSupportTicketAttachment>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSupportTicketAttachment<
  TData = Awaited<ReturnType<typeof getSupportTicketAttachment>>,
  TError = ErrorType<ErrorProblemDetails | SupportAttachmentUnavailableProblemDetails>,
>(
  orgId: string,
  ticketId: string,
  attachmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportTicketAttachment>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download a support ticket attachment
 */

export function useGetSupportTicketAttachment<
  TData = Awaited<ReturnType<typeof getSupportTicketAttachment>>,
  TError = ErrorType<ErrorProblemDetails | SupportAttachmentUnavailableProblemDetails>,
>(
  orgId: string,
  ticketId: string,
  attachmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportTicketAttachment>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSupportTicketAttachmentQueryOptions(
    orgId,
    ticketId,
    attachmentId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the maximum size and allowed types for support attachments.
 * @summary Get attachment limits
 */
export const getSupportAttachmentPolicy = (orgId: string, signal?: AbortSignal) => {
  return instance<SupportAttachmentPolicyDto>({
    url: `/orgs/${orgId}/support/attachment-policy`,
    method: 'GET',
    signal,
  });
};

export const getGetSupportAttachmentPolicyQueryKey = (orgId?: string) => {
  return [`/orgs/${orgId}/support/attachment-policy`] as const;
};

export const getGetSupportAttachmentPolicyQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupportAttachmentPolicy>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportAttachmentPolicy>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSupportAttachmentPolicyQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportAttachmentPolicy>>> = ({
    signal,
  }) => getSupportAttachmentPolicy(orgId, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSupportAttachmentPolicy>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSupportAttachmentPolicyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSupportAttachmentPolicy>>
>;
export type GetSupportAttachmentPolicyQueryError = ErrorType<ErrorProblemDetails>;

export function useGetSupportAttachmentPolicy<
  TData = Awaited<ReturnType<typeof getSupportAttachmentPolicy>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportAttachmentPolicy>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportAttachmentPolicy>>,
          TError,
          Awaited<ReturnType<typeof getSupportAttachmentPolicy>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSupportAttachmentPolicy<
  TData = Awaited<ReturnType<typeof getSupportAttachmentPolicy>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportAttachmentPolicy>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportAttachmentPolicy>>,
          TError,
          Awaited<ReturnType<typeof getSupportAttachmentPolicy>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSupportAttachmentPolicy<
  TData = Awaited<ReturnType<typeof getSupportAttachmentPolicy>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportAttachmentPolicy>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get attachment limits
 */

export function useGetSupportAttachmentPolicy<
  TData = Awaited<ReturnType<typeof getSupportAttachmentPolicy>>,
  TError = ErrorType<ErrorProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSupportAttachmentPolicy>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSupportAttachmentPolicyQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
